import { forwardRef, Select, SelectProps } from "@chakra-ui/react";
import { FormField, FormFieldProps } from "./field";

export interface FormOptionProps {
  value: string;
  option: string;
}

export interface FormSelectProps extends SelectProps {
  name: string;
  formName: string;
  label?: string;
  required: boolean;
  choices: FormOptionProps[];
  controlSx?: Omit<FormFieldProps, "isRequired">;
}

export const FormSelect = forwardRef(
  (
    {
      name,
      formName,
      label,
      required,
      choices,
      controlSx,
      ...rest
    }: FormSelectProps,
    ref: any,
  ) => {
    return (
      <FormField
        {...controlSx}
        isRequired={required || false}
        label={label}
        labelSx={{
          htmlFor: formName,
          ...controlSx?.labelSx,
        }}
      >
        <Select {...rest} ref={ref} id={formName} name={formName}>
          {choices.map((choice) => (
            <option key={choice.value} value={choice.value}>
              {choice.option}
            </option>
          ))}
        </Select>
      </FormField>
    );
  },
);
